import { render } from "./showformmodel.vue?vue&type=template&id=25490215&scoped=true"
import script from "./showformmodel.vue?vue&type=script&lang=js"
export * from "./showformmodel.vue?vue&type=script&lang=js"

import "./showformmodel.vue?vue&type=style&index=0&id=25490215&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25490215"]])

export default __exports__